import { useSyncExternalStore } from 'react';

const lists = new Map<string, MediaQueryList>();

function listFor(query: string): MediaQueryList {
  let l = lists.get(query);
  if (!l) {
    l = window.matchMedia(query);
    lists.set(query, l);
  }
  return l;
}

/** True while the media query matches; re-renders when it changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const l = listFor(query);
      l.addEventListener('change', cb);
      return () => l.removeEventListener('change', cb);
    },
    () => listFor(query).matches,
    () => false,
  );
}

/** The phone layout: bottom toolbar, sheets instead of side panels (matches the CSS breakpoint). */
export const MOBILE_QUERY = '(max-width: 720px)';
export const useIsMobile = (): boolean => useMediaQuery(MOBILE_QUERY);
